import { FormInterface } from '../../../core/interfaces/form/Form';
import { FormInput } from '../../../component/input/InputStyle';
import FormLabel from '../../../component/input/FormLabel.component';
import { ChangeEvent, useState } from 'react';
import { Store } from '../interfaces/Store';
import useDebounce from '../../../hooks/useDebounce';

export default function Form({ handleSubmitForm, initialValues, disabled }: FormInterface<Store>) {

    const [values, setValues] = useState<Store>(initialValues);
    const debounce = useDebounce(handleSubmitForm, 400);

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        const { value, name } = event.target;
        setValues({ ...values, [name]: value });
        debounce({ ...values, [name]: value });
    }

    return (
        <>
            <FormLabel title="Número Loja" sm={6} md={2}  >
                <FormInput
                    name="id"
                    value={values.id}
                    onChange={handleChange}
                    disabled={disabled}
                />
            </FormLabel>
            <FormLabel title="Nome da Loja" sm={6} md={3}  >
                <FormInput
                    name="Nome"
                    value={values.Nome}
                    onChange={handleChange}
                    disabled={disabled}
                />
            </FormLabel>
            <FormLabel title="Cidade" sm={4} md={3}  >
                <FormInput
                    name="Cidade"
                    value={values.Cidade}
                    onChange={handleChange}
                    disabled={disabled}
                />
            </FormLabel>
            <FormLabel title="Endereço" sm={4} md={2}  >
                <FormInput
                    name="Bairro"
                    value={values.Bairro}
                    onChange={handleChange}
                    disabled={disabled}
                />
            </FormLabel>
            <FormLabel title="UF" sm={4} md={2}  >
                <FormInput
                    name="UF"
                    value={values.UF}
                    onChange={handleChange}
                    disabled={disabled}
                />
            </FormLabel>
        </>
    )
}